import React, { useContext } from 'react'
import { store, actions } from '../../stores/multipost'
import SocialAccountProvider from './socialAccountProvider'
import { TextareaWithSuggestions } from './TextareaWithSuggestions'

export default function ProviderMessage({ provider, showSuggestionsTrigger = true }) {
  const { dispatch, selectedAccounts, messages, suggestions, aiSuggestionsPolicy, promptLogIds } = useContext(store)
  const disabled = !selectedAccounts.includes(provider)
  const maxLength = SocialAccountProvider.find(provider).maxCharsPerPost
  const length = messages[provider]?.value?.length || 0
  const overLength = length > maxLength
  const displayLength = overLength ? maxLength - length : length

  const onChange = (e) => {
    dispatch({
      type: actions.SET_MESSAGES,
      messages: {
        ...messages,
        [provider]: {
          value: e.target.value,
          overLength: e.target.value.length > maxLength,
        },
      },
    })
  }

  const resetSuggestions = () => {
    dispatch({
      type: actions.RESET_SUGGESTIONS,
      key: provider,
    })
  }

  const fetchSuggestions = () => {
    dispatch({
      type: actions.FETCH_SUGGESTIONS,
      key: provider,
    })
  }

  const promptLogId =
    suggestions[provider].promptLogId // user has suggestions and not dimissed them
    || promptLogIds[provider] // editing a scheduled share that previously requested suggestions

  return (
    <>
      <div className="p-2 border-bottom border-top d-flex justify-content-between align-items-center bg-muted" style={{background: 'rgba(248, 248, 248, 0.5)'}}>
        <span className="text-muted text-uppercase fw-bold ms-2" style={{fontSize: '0.75rem'}}>{SocialAccountProvider.find(provider).title} Message</span>
        <div className={overLength ? 'text-danger' : 'text-muted'}>
          {displayLength}/{maxLength}
        </div>
      </div>
      <TextareaWithSuggestions
        id={`messages-${provider}`}
        name={`team_post[messages][${provider}]`}
        value={messages[provider].value}
        onChange={onChange}
        disabled={disabled}
        showSuggestions={aiSuggestionsPolicy?.can}
        showTrigger={showSuggestionsTrigger}
        suggestions={suggestions[provider]}
        resetSuggestions={resetSuggestions}
        fetchSuggestions={fetchSuggestions}
      />
      {promptLogId && (
        <input type="hidden" name={`team_post[prompt_log_ids][${provider}]`} value={promptLogId} />
      )}
    </>
  )
}